import { isNullOrWhitespace, mapTree, pathJoin } from '@asamco/utils';

import { MainMenu, MenuItem } from '../menu-item.interface';

/**
 * Helper method to support legacy menu's
 * @param menuItem
 * @returns
 */
export function fixMenuItem(menuItem: MenuItem): MenuItem {
	let newUrl;
	if (!isNullOrWhitespace(menuItem.url)) {
		const firstIndex = menuItem.url.indexOf('#!/');
		if (firstIndex !== -1) {
			newUrl = menuItem.url.substring(firstIndex + '#!/'.length);
		} else {
			newUrl = menuItem.url;
		}
	} else {
		newUrl = menuItem.url;
	}

	return <MenuItem>{
		...menuItem,
		url: newUrl,
		icon: fixIcon(menuItem),
		caption: (menuItem['translatedCaption'] || menuItem.caption).replace(/\d*$/, ''),
		type: menuItem.caption === 'break' ? 'divider' : 'menu-item',
	};
}

// Add 'far' to the icon string
export function fixIcon(menuItem: MenuItem): string {
	if (!isNullOrWhitespace(menuItem.icon)) {
		if (menuItem.icon.includes('far')) {
			return menuItem.icon;
		} else {
			return 'far ' + menuItem.icon;
		}
	}
}

/**
 * Adds a prefix to the urls for the connected apps running in the remote app iframe
 * @param menu
 * @param remoteAppPrefix
 * @returns
 */
export function fixUrlConnectedApps(menu: MainMenu, remoteAppPrefix: string): MainMenu {
	const fixUrl = (menuItem: MenuItem) => {
		if (!isNullOrWhitespace(menuItem.url)) {
			return {
				...menuItem,
				url: pathJoin([remoteAppPrefix, menuItem.url]),
			};
		} else {
			return menuItem;
		}
	};

	return mapTree(menu, 'children', menuItem => fixUrl(menuItem));
}
